import { observer } from 'mobx-react-lite'

import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'

import { Text } from '@mxenabled/mxui'

import { useFinstrongStore } from '../../../common'
import { calculatePercentage, getEmergencySavingsState } from '../../util/finstrongUtils'

import ProgressBar from '../ProgressBar'
import { formatCurrency } from '../../../core/utils/NumberFormatting'

const copy = {
  sticky_label: 'You have saved',
}

const savingsRange = ['$0', '$250', '$500', '$750', '$1k']

const MaintainingEmergencySavingsSticky = () => {
  const { healthScore } = useFinstrongStore()

  const emergencySavings = Math.round(healthScore.emergency_savings_on_hand ?? NaN) || null

  const percentage = calculatePercentage(emergencySavings)
  const status = getEmergencySavingsState(emergencySavings)

  return (
    <ProgressBar
      bottomComponent={
        <Stack sx={{ flexDirection: 'row', justifyContent: 'space-between' }}>
          {savingsRange.map((range) => (
            <Stack key={range} sx={{ alignItems: 'center', height: 24, width: 30 }}>
              <Divider
                orientation="vertical"
                sx={{
                  borderWidth: 0.5,
                  height: 8,
                  mt: 2,
                }}
              />
              <Text variant="caption">{range}</Text>
            </Stack>
          ))}
        </Stack>
      }
      label={copy.sticky_label}
      status={status}
      statusBarData={[
        {
          percentage,
        },
      ]}
      value={formatCurrency(emergencySavings ?? 0, '0,0.00')}
    />
  )
}

export default observer(MaintainingEmergencySavingsSticky)
